import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/$tenantSlug/_layout/tool/_layout/validation/_layout")({
    component: () => <ValidationLayout />,
    loader: ({ context: { t } }) => {
        return {
            breadcrumb: t("pages.tool.scenario.validation.title"),
        };
    },
});

function ValidationLayout() {
    return <Outlet />;
}
